import api from './api';

class WorkCaseApi {
  // Tạo work case mới
  async createWorkCase(data) {
    try {
      const response = await api.post('/work-cases', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Lấy danh sách work cases
  async getWorkCases(filters = {}) {
    try {
      console.log('getWorkCases called with filters:', filters);
      const params = new URLSearchParams(filters);
      const response = await api.get(`/work-cases?${params}`);
      console.log('getWorkCases response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error in getWorkCases API call:', error);
      throw error.response?.data || error.message;
    }
  }

  // Lấy danh sách work cases của user hiện tại
  async getMyWorkCases(params = {}) {
    try {
      const response = await api.get('/work-cases/my', { params });
      // Chuẩn hóa trả về { cases, pagination }
      return response.data?.data || response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Lấy chi tiết work case
  async getWorkCaseDetail(id) {
    try {
      console.log('getWorkCaseDetail called with id:', id);
      const response = await api.get(`/work-cases/${id}`);
      console.log('getWorkCaseDetail response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error in getWorkCaseDetail API call:', error);
      throw error.response?.data || error.message;
    }
  }

  // Cập nhật status của assignment
  async updateAssignmentStatus(workCaseId, assigneeId, data) {
    try {
      console.log('updateAssignmentStatus called with workCaseId:', workCaseId, 'assigneeId:', assigneeId, 'data:', data);
      const response = await api.put(`/work-cases/${workCaseId}/assignments/${assigneeId}/status`, data);
      return response.data;
    } catch (error) {
      console.error('Error in updateAssignmentStatus API call:', error);
      throw error.response?.data || error.message;
    }
  }

  // Approve/Reject work case
  async approveRejectWorkCase(id, data) {
    try {
      console.log('approveRejectWorkCase called with id:', id, 'data:', data);
      const response = await api.post(`/work-cases/${id}/approve-reject`, data);
      return response.data;
    } catch (error) {
      console.error('Error in approveRejectWorkCase API call:', error);
      throw error.response?.data || error.message;
    }
  }

  // Thêm note cho work case
  async addNote(id, note) {
    try {
      const payload = typeof note === 'string' ? { note } : note;
      console.log('Adding note for work case:', id, 'with payload:', payload);
      const response = await api.post(`/work-cases/${id}/notes`, payload);
      return response.data;
    } catch (error) {
      console.error('Error in addNote API call:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
      throw error.response?.data || error.message;
    }
  }

  // Lấy thống kê cá nhân
  async getPersonalStats(params = {}) {
    try {
      const response = await api.get('/work-cases/stats/personal', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Admin: Lấy tất cả work cases
  async getAllWorkCases(params = {}) {
    try {
      const response = await api.get('/work-cases/admin/all', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Admin: Lấy thống kê tổng quan
  async getAdminStats(params = {}) {
    try {
      const response = await api.get('/work-cases/admin/stats', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Lấy danh sách users để assign work cases
  async getUsers() {
    try {
      const response = await api.get('/work-cases/users'); // Calls the new backend endpoint
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Lấy danh sách categories dựa trên roles
  async getCategories() {
    try {
      const response = await api.get('/work-cases/categories');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
}

export default new WorkCaseApi();
